export default "__VITE_ASSET__CngjjhCM__"